import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function CtaShape(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: 'px-6 bg-[#EDF7F8] lg:bg-[rgba(0,0,0,0)] overflow-hidden md:px-14 min-h-[340px] lg:min-h-[492px] lg:-mt-20 relative before:lg:content-[""] before:lg:block before:lg:bg-[#EDF7F8] before:lg:absolute before:lg:top-0 before:lg:right-0 before:lg:w-1/2 before:lg:h-full'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-md mx-auto text-center relative z-10 pt-12 md:pt-16 lg:pt-60"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-xl md:text-3xl font-heading font-medium"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.ctaHeading
    })), /*#__PURE__*/ React.createElement("div", {
        className: "sm:flex gap-x-4 justify-center mt-9 lg:mt-12"
    }, props.buttons.map(function(button, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: button === null || button === void 0 ? void 0 : button.target,
            className: clsx("w-full md:w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-primary focus bg-gray-600 text-white border border-gray-600 hover:bg-blue-500 hover:border-blue-500": (button === null || button === void 0 ? void 0 : button.display) === "PRIMARY",
                "button-secondary focus border-gray-600 text-gray-600 hover:bg-blue-500 hover:border-blue-500 hover:text-white": (button === null || button === void 0 ? void 0 : button.display) === "SECONDARY"
            })
        }, button === null || button === void 0 ? void 0 : button.label);
    }))), /*#__PURE__*/ React.createElement("img", {
        src: "/images/angle-panel-blue.png",
        width: "1255px",
        height: "492px",
        alt: "Angle background",
        className: "knime-hidden lg:block absolute top-2.5 lg:top-0 lg:left-14 1.5xl:left-[unset] 1.5xl:-right-20 max-w-[unset]"
    })), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "370px",
        height: "114px",
        viewBox: "0 0 370 114",
        version: "1.1",
        className: "lg:hidden absolute -bottom-6 sm:bottom-1 -right-28 sm:right-1"
    }, /*#__PURE__*/ React.createElement("title", null, "Bit Cluster/Yellow"), /*#__PURE__*/ React.createElement("g", {
        id: "Tablet",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage:Tablet-Large",
        transform: "translate(-652.000000, -3334.000000)",
        fill: "#D0ECEF"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Mid-Page-Promo-CTA",
        transform: "translate(52.000000, 3114.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Cluster/Yellow",
        transform: "translate(600.000000, 220.000000)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 73.000000) rotate(-360.000000) translate(-457.000000, -73.000000) ",
        x: "448",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 73.000000) rotate(-360.000000) translate(-393.000000, -73.000000) ",
        x: "384",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 73.000000) rotate(-360.000000) translate(-329.000000, -73.000000) ",
        x: "320",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 73.000000) rotate(-360.000000) translate(-265.000000, -73.000000) ",
        x: "256",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 73.000000) rotate(-360.000000) translate(-169.000000, -73.000000) ",
        x: "160",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(105.000000, 73.000000) rotate(-360.000000) translate(-105.000000, -73.000000) ",
        x: "96",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 73.000000) rotate(-360.000000) translate(-73.000000, -73.000000) ",
        x: "64",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(41.000000, 73.000000) rotate(-360.000000) translate(-41.000000, -73.000000) ",
        x: "32",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 105.000000) rotate(-360.000000) translate(-457.000000, -105.000000) ",
        x: "448",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 105.000000) rotate(-360.000000) translate(-425.000000, -105.000000) ",
        x: "416",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 105.000000) rotate(-360.000000) translate(-361.000000, -105.000000) ",
        x: "352",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 105.000000) rotate(-360.000000) translate(-297.000000, -105.000000) ",
        x: "288",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 105.000000) rotate(-360.000000) translate(-201.000000, -105.000000) ",
        x: "192",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 105.000000) rotate(-360.000000) translate(-169.000000, -105.000000) ",
        x: "160",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 105.000000) rotate(-360.000000) translate(-137.000000, -105.000000) ",
        x: "128",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 105.000000) rotate(-360.000000) translate(-73.000000, -105.000000) ",
        x: "64",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 137.000000) rotate(-360.000000) translate(-521.000000, -137.000000) ",
        x: "512",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(489.000000, 137.000000) rotate(-360.000000) translate(-489.000000, -137.000000) ",
        x: "480",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 137.000000) rotate(-360.000000) translate(-425.000000, -137.000000) ",
        x: "416",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 137.000000) rotate(-360.000000) translate(-329.000000, -137.000000) ",
        x: "320",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 137.000000) rotate(-360.000000) translate(-297.000000, -137.000000) ",
        x: "288",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 137.000000) rotate(-360.000000) translate(-201.000000, -137.000000) ",
        x: "192",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 169.000000) rotate(-360.000000) translate(-521.000000, -169.000000) ",
        x: "512",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 169.000000) rotate(-360.000000) translate(-457.000000, -169.000000) ",
        x: "448",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 169.000000) rotate(-360.000000) translate(-393.000000, -169.000000) ",
        x: "384",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 9.000000) rotate(-360.000000) translate(-425.000000, -9.000000) ",
        x: "416",
        y: "2.55795385e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 9.000000) rotate(-360.000000) translate(-297.000000, -9.000000) ",
        x: "288",
        y: "1.98951966e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 9.000000) rotate(-360.000000) translate(-265.000000, -9.000000) ",
        x: "256",
        y: "1.98951966e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 9.000000) rotate(-360.000000) translate(-201.000000, -9.000000) ",
        x: "192",
        y: "1.98951966e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 9.000000) rotate(-360.000000) translate(-9.000000, -9.000000) ",
        x: "0",
        y: "0",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 41.000000) rotate(-360.000000) translate(-425.000000, -41.000000) ",
        x: "416",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 41.000000) rotate(-360.000000) translate(-361.000000, -41.000000) ",
        x: "352",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 41.000000) rotate(-360.000000) translate(-265.000000, -41.000000) ",
        x: "256",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 41.000000) rotate(-360.000000) translate(-233.000000, -41.000000) ",
        x: "224",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 41.000000) rotate(-360.000000) translate(-169.000000, -41.000000) ",
        x: "160",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 41.000000) rotate(-360.000000) translate(-137.000000, -41.000000) ",
        x: "128",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 41.000000) rotate(-360.000000) translate(-73.000000, -41.000000) ",
        x: "64",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 41.000000) rotate(-360.000000) translate(-9.000000, -41.000000) ",
        x: "0",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    })))))));
}
